declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";

import { Router, ActivatedRoute } from '@angular/router';




declare var require: any;


import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { routerTransition } from '../../../../../../src/app/ncs/animations/router.animations';

import { NgbAddSession } from './modal/addsession.modal';
import { NgbEditSession } from './modal/editsession.modal';





@Component({
  selector: 'session',
  templateUrl: './session.component.html',
  styleUrls: [
    './session.component.scss']
  , animations: [routerTransition()]
})

export class SessionComponent implements OnInit {




  public ActorCode: number = 0;
  public FormattedCode: number = 0;
  public isNew: boolean = false;
  



  constructor(private router: Router,

    private modalService: NgbModal,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {



  }



  ShowList: boolean = true;


  //ExpandData() {
  //  if (this.IsExpand === true) {
  //    this.IsExpand = false;
  //  }
  //  else {
  //    this.IsExpand = true;
  //  }
  //}

  AddNewSession() {

    const modalRef = this.modalService.open(NgbAddSession,
      {
        centered: true,
       
      })


  }
  EditSession() {

    const modalRef = this.modalService.open(NgbEditSession,
      {
        centered: true,

      })


  }







}
